import { FILTER_KEYS, LOGIN_TIME_RANGES } from './constants/modalConstants';

export const getEpochForTimeRange = (timeRange) => {
  const now = new Date().getTime();

  switch (timeRange) {
    case LOGIN_TIME_RANGES.LAST_HOUR:
      return now - 60 * 60 * 1000;
    case LOGIN_TIME_RANGES.LAST_24_HOURS:
      return now - 24 * 60 * 60 * 1000;
    case LOGIN_TIME_RANGES.LAST_WEEK:
      return now - 7 * 24 * 60 * 60 * 1000;
    case LOGIN_TIME_RANGES.LAST_TWO_WEEKS:
      return now - 14 * 24 * 60 * 60 * 1000;
    case LOGIN_TIME_RANGES.LAST_MONTH:
      return now - 30 * 24 * 60 * 60 * 1000;
    case LOGIN_TIME_RANGES.LAST_YEAR:
      return now - 365 * 24 * 60 * 60 * 1000;
    default:
      return null;
  }
};

export const reliabilityOptions = [
  { label: '100%', value: 100 },
  { label: '> 90%', value: 90 },
  { label: '> 75%', value: 75 },
  { label: '> 50%', value: 50 },
  { label: '> 25%', value: 25 },
  { label: '> 10%', value: 10 },
];

export const placementScoreOptions = [
  { label: '100%', value: 100 },
  { label: '> 90%', value: 90 },
  { label: '> 75%', value: 75 },
  { label: '> 50%', value: 50 },
  { label: '> 25%', value: 25 },
  { label: '> 10%', value: 10 },
];

export const pastPlacementOptions = [
  { label: '> 1', value: 1 },
  { label: '> 5', value: 5 },
  { label: '> 10', value: 10 },
];

export const filterConfig = {
  [FILTER_KEYS.NAME]: { field: 'name', operation: 'icontains' },
  [FILTER_KEYS.RELIABILITY_SCORE]: {
    field: 'candidate.metrics.reliabilityScore',
    operation: 'equals',
  },
  [FILTER_KEYS.PLACEMENT_SUCCESS_SCORE]: {
    field: 'candidate.metrics.placementSuccessScore',
    operation: 'equals',
  },
  [FILTER_KEYS.DISTANCE]: { field: 'workerDistanceToJob' },
  [FILTER_KEYS.LAST_LOGIN_DATE]: { field: 'lastLoginDate', operation: 'greaterThanEqual' },
  [FILTER_KEYS.AGENCY]: { field: 'candidate.agency.ID', operation: 'equalsID' },
  [FILTER_KEYS.RECRUITER]: { field: 'candidate.recruiter.ID', operation: 'equalsID' },
  [FILTER_KEYS.NO_FUTURE_WORK]: { field: 'futureScheduledHours', operation: 'equals' },
  [FILTER_KEYS.INDUSTRY_MEETS_PREF]: { field: 'industryMeetsPreferences', operation: 'equals' },
  [FILTER_KEYS.PAY_RATE_MEETS_PREF]: { field: 'payRateMeetsPreferences', operation: 'equals' },
  [FILTER_KEYS.SHIFT_TIME_MEETS_PREF]: { field: 'shiftTimeMeetsPreferences', operation: 'equals' },
  [FILTER_KEYS.WOTC_ELIGIBLE]: {
    field: 'candidate.taxCreditOpportunities.wotc.isEligible',
    operation: 'equals',
  },
  [FILTER_KEYS.URBAN_YOUTH_CERTIFIED]: {
    field: 'candidate.taxCreditOpportunities.nyUrbanYouth.isCertified',
    operation: 'equals',
  },
};

export const agencyAPICallback = {
  httpMethod: 'POST',
  route: 'agency/read',
  generateBody: (searchTerm) => ({
    filters: [{ operation: 'icontains', field: 'name', value: searchTerm }],
  }),
};

export const recruiterAPICallback = (recruiterId) => ({
  httpMethod: 'POST',
  route: 'V2/users/read',
  generateBody: (searchTerm) => {
    const hasValidId = recruiterId && (!Array.isArray(recruiterId) || recruiterId.length > 0);
    const filters = hasValidId
      ? [{ operation: 'equalsID', field: '_id', value: recruiterId }]
      : [
          { operation: 'equals', field: 'role', value: 'recruiter' },
          ...(searchTerm ? [{ operation: 'icontains', field: 'name', value: searchTerm }] : []),
        ];
    return { filters };
  },
});

export const getLastLoginOptions = (LanguageConverterV2) => [
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastHour'),
    value: LOGIN_TIME_RANGES.LAST_HOUR,
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastDay'),
    value: LOGIN_TIME_RANGES.LAST_24_HOURS,
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastWeek'),
    value: LOGIN_TIME_RANGES.LAST_WEEK,
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastTwoWeek'),
    value: LOGIN_TIME_RANGES.LAST_TWO_WEEKS,
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastMonth'),
    value: LOGIN_TIME_RANGES.LAST_MONTH,
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.lastLogin.lastYear'),
    value: LOGIN_TIME_RANGES.LAST_YEAR,
  },
];

export const getSortByOptions = (LanguageConverterV2) => [
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.sortBy.newestLogin'),
    value: 'newest',
  },
  {
    name: LanguageConverterV2('dashboard.recommendWorkerModal.sortBy.oldestLogin'),
    value: 'oldest',
  },
];

export const formatDisplayPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return 'N/A';

  const cleaned = phoneNumber.replace(/\D/g, '');

  if (cleaned.length === 10 && /^[2-9]\d{2}[2-9]\d{2}\d{4}$/.test(cleaned)) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return 'N/A';
};
